/**
 * 奇樹製造器：一種底，調葉色／花／果／光。不混物種。
 */

import { useGameStore } from '../core/store/gameStore'
import {
  ENCOUNTER_LABEL,
  FLOWER_KINDS,
  FRUIT_KINDS,
  LEAF_TINTS,
  TREE_BASES,
  defaultPlantForm,
} from '../content/partLibrary'
import type { EncounterKind } from '../content/types'

export function PlantMaker() {
  const draft = useGameStore(s => s.plantDraft)
  const setPlantDraft = useGameStore(s => s.setPlantDraft)
  const setMakerOpen = useGameStore(s => s.setMakerOpen)
  const setPlacingBeast = useGameStore(s => s.setPlacingBeast)
  const setToolGroup = useGameStore(s => s.setToolGroup)
  const visitMode = useGameStore(s => s.visitMode)
  const form = { ...defaultPlantForm(), ...draft.plantForm }

  if (visitMode) return null

  return (
    <div className="beast-maker">
      <div className="beast-maker-head">
        <span className="beast-maker-title">奇樹製造</span>
        <button type="button" className="panel-close" onClick={() => setMakerOpen(false)}>×</button>
      </div>
      <div className="beast-maker-cols plant-maker-cols">
        <section>
          <h3>形</h3>
          <label className="beast-field">
            名
            <input
              value={draft.name}
              onChange={e => setPlantDraft({ name: e.target.value })}
              maxLength={12}
            />
          </label>
          <div className="beast-slot">
            <span>底</span>
            <div className="beast-chips">
              {TREE_BASES.map(b => (
                <button
                  key={b.id}
                  type="button"
                  className={form.base === b.id ? 'active' : ''}
                  onClick={() => setPlantDraft({ plantForm: { ...form, base: b.id } })}
                >
                  {b.name}
                </button>
              ))}
            </div>
          </div>
          <label className="beast-field">
            株
            <input
              type="range"
              min={0}
              max={12}
              step={1}
              value={form.seed}
              onChange={e => setPlantDraft({ plantForm: { ...form, seed: Number(e.target.value) } })}
            />
          </label>
          <div className="beast-slot">
            <span>葉</span>
            <div className="beast-chips">
              {LEAF_TINTS.map(t => (
                <button
                  key={t.id}
                  type="button"
                  className={form.leafTint === t.hex ? 'active' : ''}
                  onClick={() => setPlantDraft({ plantForm: { ...form, leafTint: t.hex } })}
                >
                  {t.name}
                </button>
              ))}
            </div>
          </div>
        </section>
        <section>
          <h3>華實</h3>
          <div className="beast-slot">
            <span>花</span>
            <div className="beast-chips">
              {FLOWER_KINDS.map(f => (
                <button
                  key={f.id}
                  type="button"
                  className={form.flower === f.id ? 'active' : ''}
                  onClick={() => setPlantDraft({ plantForm: { ...form, flower: f.id } })}
                >
                  {f.name}
                </button>
              ))}
            </div>
          </div>
          <div className="beast-slot">
            <span>果</span>
            <div className="beast-chips">
              {FRUIT_KINDS.map(f => (
                <button
                  key={f.id}
                  type="button"
                  className={form.fruit === f.id ? 'active' : ''}
                  onClick={() => setPlantDraft({ plantForm: { ...form, fruit: f.id } })}
                >
                  {f.name}
                </button>
              ))}
            </div>
          </div>
          <button
            type="button"
            className={`beast-choice ${form.glow ? 'active' : ''}`}
            onClick={() => setPlantDraft({ plantForm: { ...form, glow: !form.glow } })}
          >
            其華四照
          </button>
          <p className="beast-hint">客人走近時</p>
          {(Object.keys(ENCOUNTER_LABEL) as EncounterKind[]).map(k => (
            <button
              key={k}
              type="button"
              className={`beast-choice ${draft.encounter === k ? 'active' : ''}`}
              onClick={() => setPlantDraft({ encounter: k })}
            >
              {ENCOUNTER_LABEL[k]}
            </button>
          ))}
          {draft.encounter === 'message' && (
            <label className="beast-field">
              短訊
              <input
                value={draft.encounterMessage ?? ''}
                onChange={e => setPlantDraft({ encounterMessage: e.target.value })}
                maxLength={24}
              />
            </label>
          )}
        </section>
      </div>
      <div className="beast-maker-foot">
        <button
          type="button"
          className="btn-primary"
          onClick={() => {
            setToolGroup('plant')
            setPlacingBeast(true)
            setMakerOpen(false)
          }}
        >
          種上山
        </button>
        <span className="beast-hint">一種底，奇在色、花、果、光</span>
      </div>
    </div>
  )
}
